<template>
    <!-- 发票申请 -->
    <div class="wid-12">
        <div class="" style=""
            v-show="$route.meta.showFather && this.$route.fullPath =='/personal/service/invoice/index'">
            <div class="box-shadow mb-16 ">
                <div class="flex-1 jus-bet pad-16 cursor" @click="myInvoice">
                    <div class="flex-1">
                        <img src="../../../../assets/myself/fapiao.png" alt="">
                        <p class="record-1">我的发票</p>
                    </div>
                    <i class="el-icon-arrow-right" style="color: #666666;font-size: 18px;"></i>
                </div>

            </div>


            <div class="box-shadow pad-16">
                <el-table ref="multipleTable" :data="tableData" class="box-table" style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="30">
                    </el-table-column>
                    <el-table-column prop="name" label="" show-overflow-tooltip>
                        <template slot-scope="scope"><span>商品名称:</span>{{scope.row.name }}</template>
                    </el-table-column>
                    <el-table-column prop="no" label="" show-overflow-tooltip>
                        <template slot-scope="scope"><span>订单编号:</span>{{ scope.row.no }}</template>
                    </el-table-column>
                    <el-table-column prop="payPrice" label="" show-overflow-tooltip>
                        <template slot-scope="scope"><span>支付金额:</span>{{ scope.row.payPrice }}元</template>
                    </el-table-column>
                    <el-table-column prop="payTime" label="" show-overflow-tooltip>
                        <template
                            slot-scope="scope"><span>购买时间:</span>{{ utils.getNowTime(scope.row.payTime) }}</template>
                    </el-table-column>
                </el-table>
                <div class="flex-1 jus-bet" style="margin-top: 1.5rem;">
                    <el-checkbox v-model="checked" @change="allSelect">全选</el-checkbox>
                    <el-button type="primary" @click="apply">申请开票</el-button>
                    <!-- <el-button @click="toggleSelection()">取消选择</el-button> -->
                    <!-- <el-button @click="allSelect()()">全选</el-button> -->
                </div>

            </div>

        </div>
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
    import {
        getOrderList
    } from '@/api/personal/api.js';
    export default {
        components: {},
        data() {
            return {
                activeName: '',
                form: {

                },
                tableData: [],
                multipleSelection: [],
                checked: false,

                activityOrderIds: [],
                levelOrderIds: [],
                priceList: ''
            }

        },
        mounted() {
            this.getList()
        },
        methods: {
            getList() {
                getOrderList().then(res => {
                        this.tableData = res.data;
                    })
                    .catch(error => {

                    });
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (this.multipleSelection.length == this.tableData.length) {
                    this.checked = true;
                } else {
                    this.checked = false;
                }
                // console.log(this.multipleSelection,'this.multipleSelection')
                let levelOrderIds = [];
                let activityOrderIds = [];
                let price = []
                this.multipleSelection.forEach((item, index) => {
                    if (item.orderType == 1) {
                        levelOrderIds.push(item.id)
                    } else if (item.orderType == 2) {
                        activityOrderIds.push(item.id)
                    }
                    price.push(item.payPrice)

                })
                console.log(price, 'price')

                function sum(price) {
                    return eval(price.join("+"));
                };
                this.priceList = sum(price)
                console.log(this.priceList, 'sunm')



                this.activityOrderIds = activityOrderIds;
                this.levelOrderIds = levelOrderIds;
            },
            allSelect() {
                console.log(this.multipleSelection)
                this.$refs.multipleTable.toggleAllSelection();
            },
            // 填写信息
            apply() {
                if (this.multipleSelection == 0) {
                    this.$message.warning('至少选择一条数据！')
                } else {
                    this.$router.push({
                        name: '/invoice/inInformation',
                        params: {
                            levelOrderIds: this.levelOrderIds,
                            activityOrderIds: this.activityOrderIds,
                            amount: this.priceList,
                        }
                    })
                }

                // this.$router.push("/personal/service/invoice/inInformation");
            },
            // 我的发票
            myInvoice() {
                this.$router.push("/personal/service/invoice/myInvoice");
            }
        }
    }
</script>

<style>

</style>
<style scoped>
    .box-shadow {
        box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
        border-radius: 8px 8px 8px 8px;
    }

    .pad-16 {
        padding: 16px;
    }

    .flex-1 {
        display: flex;
        align-items: center;
    }

    .jus-bet {
        justify-content: space-between;
    }

    /*    .record {
        font-size: 14px;
        color: #333333;
        line-height: 21px;
        margin-right: 8px;
    } */

    .record-1 {
        font-size: 20px;
        color: #222222;
        padding-left: 16px;
    }

    .mb-32 {
        margin-bottom: 32px;
    }

    .mb-16 {
        margin-bottom: 16px;
    }

    /deep/.el-checkbox__inner {
        border-radius: 25px;
        width: 1.125rem;
        height: 1.125rem;
        border: 1px solid #999999;
    }

    /deep/.el-table .has-gutter .el-checkbox .el-checkbox__inner {
        display: none;
    }

    /deep/.el-table__header-wrapper {
        display: none;
    }

    /deep/.el-checkbox__inner::after {
        border: 0.125rem solid #ffffff;
        width: 0.375rem;
        border-left: 0;
        border-top: 0;
        height: 0.5625rem;
        top: 0.0625rem;
        transform: rotate(45deg) scaleY(1.1);
    }

    /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #3377FF;
    }

    .box-table span {
        color: #999999;
        font-size: 14px;
        padding-right: 0.5rem;
    }

    /deep/.el-table .cell.el-tooltip {
        color: #222222;
        font-size: 14px;
    }

    /deep/.el-table .cell {
        padding: 0;
    }

    .el-button--primary {
        background-color: #3377FF;
        color: #ffffff;
        border-radius: 35px;
    }

    .el-button--primary span {
        font-size: 16px;
        padding: 0.75rem 0;
    }

    /deep/.box-table .el-table__row:hover>td {
        background-color: transparent !important;
    }
</style>
